import { HolidayModel } from "../models/HolidayModel";
import { IHttpRequestService } from "./HttpRequestService";

export interface IHolidayService {
    GetHolidaysByYearId(schoolYearId?: number): Promise<HolidayModel[]>;
    GetHolidaysByCalendarYear(calendarYear: number): Promise<HolidayModel[]>;
    GetHoliday(id: number): Promise<HolidayModel>;
    Save(data: HolidayModel): Promise<HolidayModel | undefined>;
    Delete(id: number): Promise<boolean>;
}

export class HolidayService implements IHolidayService {
    constructor(private httpRequestService: IHttpRequestService) {}

    public async GetHolidaysByYearId(yearId?: number): Promise<HolidayModel[]> {
        try {
            const url = `/api/v1/Holiday/Year/${yearId}`;
            const { data } = await this.httpRequestService.Get<HolidayModel[]>(url);
            if(!data || data.length == 0) { return []; }
            return data as HolidayModel[];
        } catch (e) {
            this.httpRequestService.HandleError(e);
        }
        return [];
    }

    public async GetHolidaysByCalendarYear(calendarYear: number): Promise<HolidayModel[]> {
        try {
            const url = `/api/v1/Holiday/CalendarYear/${calendarYear}`;
            const { data } = await this.httpRequestService.Get<HolidayModel[]>(url);
            if(!data || data.length == 0) { return []; }
            return data as HolidayModel[];
        } catch (e) {
            this.httpRequestService.HandleError(e);
        }
        return [];
    }

    public async GetHoliday(id: number): Promise<HolidayModel> {
        try {
            const { data } = await this.httpRequestService.Get<HolidayModel>(`/api/v1/Holiday/${id}`);
            return data as HolidayModel;
        } catch (e) {
            this.httpRequestService.HandleError(e);
        }
        return new HolidayModel();
    }

    public async Save(data: HolidayModel): Promise<HolidayModel | undefined> {
        try {
            const response = data.id > 0
                ? await this.httpRequestService.Put<HolidayModel, HolidayModel>(`/api/v1/Holiday/Update`, data)
                : await this.httpRequestService.Post<HolidayModel, HolidayModel>(`/api/v1/Holiday/Add`, data);

            if (response) {
                return response as HolidayModel;
            }
        } catch (e) {
            this.httpRequestService.HandleError(e);
        }
        return undefined;
    }

    public async Delete(id: number): Promise<boolean> {
        try {
            await this.httpRequestService.DeleteById<boolean>(`/api/v1/Holiday/${id}`);
            return true;
        } catch (e) {
            this.httpRequestService.HandleError(e);
        }
        return false;
    }
}
